import { isMobile, isPad } from "./uilts";

import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { gsap } from "gsap";
import { createResultCollector } from './improvise';

class ImpactCampus {

    //=================================================
    // 타임라인.
    //=================================================
    impactCampusTimeline;
    lottieLineTimeline;

    videoDimTimeline;

    //=================================================
    // 엘리먼트.
    //=================================================
    // * 네비게이션 바 / 메뉴
    menuBtnElem;        // 메뉴 버튼.
    menuBtnArrowElem;   // 메뉴 버튼 화살표.
    menuListElem;       // 메뉴 목록.
    menuIntroElem;          // 메뉴 - Intro.
    menuImpactClusterElem;  // 메뉴 - ImpactCluster.
    menuImpactCampusElem;   // 메뉴 - ImpactCampus.
    menuVisionElem;         // 메뉴 - vision.
    menuCelebrationElem;    // 메뉴 - celebration.

    // * 세션.
    introElem;            // 세션 루트 - Intro.
    impactClusterElem;    // 세션 루트 - ImpactCluster.
    impactCampusElem;     // 세션 루트 - ImpactCampus.  #3-1 ~
    impactCampus2Elem;     // 세션 루트 - ImpactCampus.  #3-21
    impactCampus3Elem;     // 세션 루트 - ImpactCampus.  #3-22 ~
    visionElem;           // 세션 루트 - vision.
    celebrationElem;      // 세션 루트 - celebration.

    //* #3. Cluster-Campus 엘리먼트.
    campusDivHorizontalWrapper; // 아래 엘리먼트들의 부모.
    campusDivList;        // Impact Campus 세션 내 child div 목록.
    scatterImgElemList;   // 이미지 리스트.
    messageElemList;      // 메시지 리스트.
    seedElem;             // 씨앗 svg.
    stemElem;         // 줄기 svg;
    leafLeftElem;     // 왼쪽 잎 svg.
    leafRightElem;    // 오른쪽 잎 svg.
    waveElem;         // 씨앗 뒤 파동 svg.

    bgline1Elem;       // 백그라운드 라인 (앞부분).
    bgline1AfterElem;  // 백그라운드 라인 (뒷부분).
    bgline2Elem;      // 백그라운드 라인 (뒷부분 - 역방향)

    bgGreenline1Elem;   // 백그라운드 라인 (녹색).
    bgGreenline2Elem;   // 백그라운드 라인 (녹색).
    bgGreenline3Elem;   // 백그라운드 라인 (녹색).

    campusHorizontalWrapper;
    campusHorziontal1Items; // 가로스크롤 1 아이템 목록.

    rootImpactLogo;
    rootImpactLogoReverse;

    // 프로그램 소개 ( #3-08 )
    leafGroup;
    leafSvgList;
    leaf01svg;
    leaf01bg;
    leaf01TextList;
    leaf01Img;

    leaf02svg;
    leaf02bg;
    leaf02TextList;
    leaf02Img;

    leaf03svg;
    leaf03bg;
    leaf03TextList;
    leaf03Img;

    leaf04svg;
    leaf04bg;
    leaf04TextList;
    leaf04Img;

    leafMsgList;

    // #3-12
    title312Elem;

    // #3-13
    pictoWrapper;
    pictoList;        // 픽토그램 아이콘 목록.
    pictoNextList;    // 다음 픽토그램(#3-14) 아이콘 목록.
    pictoMessage1;    // 픽토그램 메시지.

    ibcDescElem;


    campusScrollerWrapperElem;  // 커리어 가로.세로구간 이동 제어를 위한 엘리먼트.

    // #3-17
    careerItemTexts;   // 커리어기회, 취업률 엘리먼트. ( 텍스트 )
    careerItemImgs;   // 커리어기회, 취업률 엘리먼트. ( 이미지 )


    // #3-18
    partsItems;         // 텍스트 및 부서 목록.
    partMsg;            // 메시지.

    recommendPerson1Elem;
    recommendPerson2Elem;

    // 영상.
    videoPlayWrapperElem;           // 비디오 클릭 영역 표시.
    playbtnElem;                    // 클러스터 영상 팝업 띄우기.

    dimmElem;                       // 비디오 백그라운드 배경.
    videoCampusPopupElem;           // 비디오 팝업.
    isOpenCampusVideo;              // 팝업 오픈 여부.


    //===================================================================
    // 트랜지션 커버 제어용
    //===================================================================
    clusterCoverElem;   // 이전 세션 커버.
    campusCoverElem;    // 현재 세션 커버.

    //===================================================================
    // 비전
    //===================================================================
    visionWrapperElem;
    visionCircleElem;
    visionbgElem;


    // GNB
    gnbGlobalNavbar;
    gnbDropdown;

    //Vimeo
    vimeoPlayer;

    //=================================================
    // 전역 변수 / 상수
    //=================================================
    dropdownMenuHeight;
    scrollTriggerPinElemHeightRatio = 12;

    constructor() {
        // GSAP 초기화.
        // gsap.registerPlugin(ScrollTrigger);
        // gsap.registerPlugin(ScrollToPlugin);
    }

    init() {
        this.gnbGlobalNavbar = document.querySelector('nav.global-nav');
        this.gnbDropdown = document.querySelector('nav .dropdown-menu');

        // * 세션.
        this.impactCampusElem = document.querySelector('#impact-campus');
        this.impactCampus2Elem = document.querySelector('#impact-campus-2');

        // * #3 Impact Campus.
        this.campusDivHorizontalWrapper = document.querySelector('.ic-phase-wrapper');
        this.campusDivList = gsap.utils.toArray('div.ic-phase1');

        // 이미지 목록.
        this.scatterImgElemList = [];
        this.impactCampusElem.querySelectorAll('.campus-img-wrapper .campus-image-frame').forEach((elem) => {
            this.scatterImgElemList.push(elem);
        });

        // 메시지 목록.
        this.messageElemList = [];
        this.impactCampusElem.querySelectorAll('.campus-message-wrapper').forEach((elem) => {
            this.messageElemList.push(elem);
        });

        this.leafMsgList = [];
        document.querySelectorAll('.global-message-wrapper .message.leafmsg.left').forEach((elem) => {
            this.leafMsgList.push(elem);
        });

        // 로고.
        this.rootImpactLogo = document.querySelector('.nav-logo-wrapper .logo');
        this.rootImpactLogoReverse = document.querySelector('.nav-logo-wrapper .logo-reverse');


        // 씨앗 svg.
        this.seedElem = this.impactCampusElem.querySelector('.campus-seed-wrapper');
        this.stemElem = this.impactCampusElem.querySelector('.campus-seed-wrapper #stem');
        this.leafLeftElem = this.impactCampusElem.querySelector('.campus-seed-wrapper #leaf-left');
        this.leafRightElem = this.impactCampusElem.querySelector('.campus-seed-wrapper #leaf-right');
        this.waveElem = this.impactCampusElem.querySelector('.campus-wave-wrapper .wave');

        // 가로 배경 - 라인 백그라운드. (노랑)
        this.bgline1Elem = this.impactCampusElem.querySelector('#lottie-bg-yellow-1.background-line-yellow');
        this.bgline1AfterElem = this.impactCampusElem.querySelector('#lottie-bg-yellow-1-1.background-line-yellow');
        this.bgline2Elem = this.impactCampusElem.querySelector('#lottie-bg-yellow-2.background-line-yellow');

        this.bgGreenline1Elem = this.impactCampusElem.querySelector('#lottie-bg-green-1');
        this.bgGreenline2Elem = this.impactCampusElem.querySelector('#lottie-bg-green-2');
        this.bgGreenline3Elem = this.impactCampusElem.querySelector('#lottie-bg-green-3');

        // 첫번째 가로 스크롤 루트.
        this.campusHorizontalWrapper = this.impactCampusElem.querySelector('.campus-horizontal-wapper');
        // 첫번째 가로 스크롤에 소속된 아이템 리스트.
        this.campusHorziontal1Items = this.campusHorizontalWrapper.querySelectorAll('.campus-horizontal-item');


        // 프로그램 소개 잎모양. (svg 파일 내 id 체크 필수.)
        this.leafGroup = this.campusHorizontalWrapper.querySelector('.campus-leaf-wrapper'); // 루트 요소.
        this.leafSvgList = this.leafGroup.querySelectorAll('svg');      // 그룹 내 svg 목록.
        // 01. Program.
        this.leaf01svg = this.campusHorizontalWrapper.querySelector('#leaf01');
        this.leaf01bg = this.leaf01svg.querySelector('#leaf01bg');      // 잎 배경.
        this.leaf01TextList = gsap.utils.toArray('#leaf01TextList');    // 텍스트.
        this.leaf01Img = this.leaf01svg.querySelector('#leaf01Img');    // 이미지.
        // 02. Community.
        this.leaf02svg = this.campusHorizontalWrapper.querySelector('#leaf02');
        this.leaf02bg = this.leaf02svg.querySelector('#leaf02bg');      // 잎 배경.
        this.leaf02TextList = gsap.utils.toArray('#leaf02TextList');    // 텍스트.
        this.leaf02Img = this.leaf02svg.querySelector('#leaf02Img');    // 이미지.
        // 03. Matching.
        this.leaf03svg = this.campusHorizontalWrapper.querySelector('#leaf03');
        this.leaf03bg = this.leaf03svg.querySelector('#leaf03bg');      // 잎 배경.
        this.leaf03TextList = gsap.utils.toArray('#leaf03TextList');    // 텍스트.
        this.leaf03Img = this.leaf03svg.querySelector('#leaf03Img');    // 이미지.
        // 04. Co-learning Space.
        this.leaf04svg = this.campusHorizontalWrapper.querySelector('#leaf04');
        this.leaf04bg = this.leaf04svg.querySelector('#leaf04bg');      // 잎 배경.
        this.leaf04TextList = gsap.utils.toArray('#leaf04TextList');    // 텍스트.
        this.leaf04Img = this.leaf04svg.querySelector('#leaf04Img');    // 이미지.

        this.ibcDescElem =this.campusHorizontalWrapper.querySelector('.campus-horizontal-item.st3-15 .desc-contents .graph-desc');

        this.title312Elem = this.campusHorizontalWrapper.querySelector('.campus-horizontal-item-content img');

        this.pictoWrapper = this.campusHorizontalWrapper.querySelector('.campus-picto-wrapper');
        this.pictoList = gsap.utils.toArray('.campus-picto-wrapper .picto-item');
        this.pictoNextList = gsap.utils.toArray('#picto-next');

        this.pictoMessage1 = this.campusHorizontalWrapper.querySelector('#message-program-130');
        this.pictoMessage2 = this.campusHorizontalWrapper.querySelector('#message-program-1500');


        this.campusScrollerWrapperElem = document.querySelector('.campus-scroll-wrapper');

        this.careerItemImgs = gsap.utils.toArray('.items .item-svg .img');
        this.careerItemTexts = gsap.utils.toArray('.items .item-svg .text');

        this.partsItems = gsap.utils.toArray('.partsItem');
        this.partMsg = document.querySelector('.partMsg');

        this.recommendPerson1Elem = document.querySelector('.campus-recommend-wrapper.pos1');
        this.recommendPerson2Elem = document.querySelector('.campus-recommend-wrapper.pos2');

        this.videoPlayWrapperElem = document.querySelector('#campus-playbtn');
        this.dimmElem = document.querySelector('.container .background-dim');
        this.videoCampusPopupElem = document.querySelector('.container #video-campus');

        this.vimeoPlayer = new Vimeo.Player(document.querySelector('#iframe-campus'));
        
        this.playbtnElem = document.querySelector('#play-campus-video');
        this.playbtnElem.addEventListener('click', () => {
            if(this.isOpenCampusVideo) return;
            this.isOpenCampusVideo = true;
            this.setVideoPopup('flex');
            this.vimeoPlayer.play();
        });

        document.querySelectorAll('#close-video-campus').forEach((elem) => {
            elem.addEventListener('click', () => {
                this.vimeoPlayer.pause();
                this.isOpenCampusVideo = false;
                this.setVideoPopup('none');
            })
        });

        this.clusterCoverElem = document.querySelector('.transiton-cover.cluster-page');
        this.campusCoverElem = document.querySelector('.transiton-cover.campus-page');
        
        this.visionWrapperElem = document.querySelector('.vision-wrapper');
        this.visionCircleElem = this.visionWrapperElem.querySelector('.vison-circle');
        this.visionbgElem = this.visionWrapperElem.querySelector('.vison-bg');

        return this.initTimelines();
    }

    // window resize 이벤트 호출시 동작.
    refresh() {
        this.impactCampusTimeline.invalidate();
    }

    /**
     * 비디오 팝업 제어.
     * @param {'flex' | 'none'} state : 팝업 열림 / 닫힘.
     */
    setVideoPopup(state) {
        this.isOpenCampusVideo = (state === 'flex');
        document.querySelector('body').style.overflow = this.isOpenCampusVideo ? 'hidden' : 'visible';
        this.dimmElem.style.display = state;
        this.videoCampusPopupElem.style.display = state;
    }
    

    // ScrollTrigger Pin 엘리먼트의 사용자지정 높이 값.
    impactCampusVerticalPinHeight(multiple) {
        if (this.impactCampusElem) {
            return this.impactCampusElem.offsetHeight * multiple;
        } else {
            console.error('Init InpactCampus Element first.');
            return 0;
        }
    }

    /**
     * 세션별 시작 좌표 값 초기화.
     */
    initSectionPos() {
        if (this.introElem) this.introElem.setAttribute('beginPos', this.introElem.offsetTop);
        if (this.impactClusterElem) this.impactClusterElem.setAttribute('beginPos', this.impactClusterElem.offsetTop);
        if (this.impactCampusElem) this.impactCampusElem.setAttribute('beginPos', this.impactClusterElem.offsetTop + this.impactClusterElem.offsetHeight); // 이전 세션의 시작점 + 이전세션의 너비 => 다음 세션의 시작점.
        if (this.visionElem) this.visionElem.setAttribute('beginPos', this.visionElem.offsetTop);
        if (this.celebrationElem) this.celebrationElem.setAttribute('beginPos', this.celebrationElem.offsetTop);

    }

    /**
     * 각 세션별 타임라인 초기화.
     */
    initTimelines() {
        // #3.Impact Campus 타임라인.
        this.impactCampusTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.impactCampusElem,
                start: () => "top top",
                end: () => `+=5200%`,
                scrub: 1,
                pin: true,
                // markers: true,
                pinSpacing: true,
                invalidateOnRefresh: true,
                id: 'impact-campus',
                preventOverlaps: true,
                fastScrollEnd: true
            }
        });

        this.lottieLineTimeline = gsap.timeline({
            scrollTrigger: {
                trigger: this.impactCampus2Elem,
                start: "top top",
                // end: () => this.impactCampus2Elem.offsetTop + (window.innerWidth * 4) - window.innerHeight,
                scrub: 1,
                invalidateOnRefresh: true,
                // markers: true,
                id: 'green-line-group'
            }
        });

        this.impactCampusTimeline.to({}, {duration: 5});
        this.impactCampusTimeline.to(this.clusterCoverElem, {y:() => -window.innerHeight, duration: 5});
        // 루트임팩트 로고 색상 반전.
        // if(!isMobile()) {
            this.impactCampusTimeline.fromTo(this.rootImpactLogo, {opacity: 0 }, {opacity: 1, duration: 1},"-=5");
            this.impactCampusTimeline.fromTo(this.rootImpactLogoReverse, {opacity: 1 }, {opacity: 0, duration: 1,
                onComplete: () => this.updateGNB('light'),
                onReverseComplete: () => this.updateGNB('dark')
            },"-=5");
        // }
        this.impactCampusTimeline.set(this.clusterCoverElem, {visibility: 'hidden'});

        // 동시에 플레이한 애니메이션 그룹 초기화.
        // this.impactCampusTimeline.add('test');
        // this.impactCampusTimeline.add('visible', '+=1');
        // this.impactCampusTimeline.add('moveToCenter', 'visible+=16');
        // this.impactCampusTimeline.add('hide', 'visible+=16');
        // this.impactCampusTimeline.add('seed', 'visible+=15');
        // this.impactCampusTimeline.add('horizontal', 'seed+=11');
        // this.impactCampusTimeline.add('horizontal-line', 'horizontal');
        // this.impactCampusTimeline.add('leafs', 'horizontal+=14');


        // this.messageElemList.forEach((elem, index) => {
        //     // 메시지 시작 제어.
        //     switch (index) {
        //         case 0: this.impactCampusTimeline.fromTo(elem, { opacity: 1 }, { opacity: 1, duration: 10 }); break; // '우리는 사회...'
        //         case 1: this.impactCampusTimeline.fromTo(elem, { opacity: 0 }, { opacity: 1, duration: 10 }); break; // '더 커다란...'
        //         case 2: this.impactCampusTimeline.fromTo(elem, { opacity: 0 }, { opacity: 1, duration: 10 }); break; // '그래서 우리는 ...' 이전 텍스트 페이드아웃 1 + 트랜지션,알파 (동시 1) + 씨앗 2 
        //     }
        //     // 메시지 종료 제어. ( 마지막 문장은 유지 )
        //     if (index !== 2) this.impactCampusTimeline.fromTo(elem, { opacity: 1 }, { opacity: 0, duration: 5 }, '+=5');
        // });

        // [이미지 애니메이션] - 알파값 제어.
        // this.scatterImgElemList.forEach((elem, index) => {
        //     if (index === 0) this.impactCampusTimeline.fromTo(elem, { opacity: 0 }, { opacity: 1, duration: 5 }, "visible");
        //     else this.impactCampusTimeline.fromTo(elem, { opacity: 0 }, { opacity: 1, duration: 5 }, `visible+=${index - 1}`);
        // });

        this.impactCampusTimeline.fromTo(this.messageElemList[0], { opacity: 1 }, { opacity: 1, duration: 10 }); // '우리는 사회...'

        this.impactCampusTimeline.fromTo(this.scatterImgElemList[0], { opacity: 0 }, { opacity: 1, duration: 10 });
        this.impactCampusTimeline.fromTo(this.scatterImgElemList[5], { opacity: 0 }, { opacity: 1, duration: 10 },"-=4");
        this.impactCampusTimeline.fromTo(this.scatterImgElemList[4], { opacity: 0 }, { opacity: 1, duration: 10 }, "-=2");

        this.impactCampusTimeline.fromTo(this.messageElemList[0], { opacity: 1 }, { opacity: 0, duration: 5 }, '+=5');
        this.impactCampusTimeline.fromTo(this.messageElemList[1], { opacity: 0 }, { opacity: 1, duration: 10 }); // '더 커다란...'

        this.impactCampusTimeline.fromTo(this.scatterImgElemList[2], { opacity: 0 }, { opacity: 1, duration: 10 },"-=10");
        this.impactCampusTimeline.fromTo(this.scatterImgElemList[1], { opacity: 0 }, { opacity: 1, duration: 10 },"-=2");
        this.impactCampusTimeline.fromTo(this.scatterImgElemList[3], { opacity: 0 }, { opacity: 1, duration: 10 },"-=3");

        this.impactCampusTimeline.fromTo(this.messageElemList[1], { opacity: 1 }, { opacity: 0, duration: 10 }, '+=5');

        // [이미지 애니메이션] - 트랜지션 센터.
        // 화면비 좌표값 : main.css - campus-image-frame#pic 참고.
        if(isMobile()) {
            const imgPosXList = [
                -108,
                -77,
                -45,
                60,
                100,
                110,

            ];
            const imgPosYList = [
                -117,
                190,
                -231,
                267,
                134,
                -155
            ];
            this.scatterImgElemList.forEach((elem, index) => {
                this.impactCampusTimeline.fromTo(elem, { x: () => imgPosXList[index], y: () => imgPosYList[index] }, { x: () => 0, y: () => 0, opacity: 0, duration: 10 }, index === 0 ? '+=0' : '-=10');
            });
        } else if(isPad()) {
            const imgPosXList = [
                -316,
                -294,
                -145,
                -22,
                285,
                330,
            ];
            const imgPosYList = [
                -158,
                190,
                -401,
                431,
                162,
                -271
            ];
            this.scatterImgElemList.forEach((elem, index) => {
                this.impactCampusTimeline.fromTo(elem, { x: () => imgPosXList[index], y: () => imgPosYList[index] }, { x: () => 0, y: () => 0, opacity: 0, duration: 30 }, index === 0 ? '+=0' : '-=30');
            });

        } else {
            const imgPosXList = [6.25, 13.64, 35.31, 43.22, 65.41, 72.91];
            const imgPosYList = [28.51, 68.24, 17.31, 77.68, 54.13, 20.09];
            this.scatterImgElemList.forEach((elem, index) => {
                this.impactCampusTimeline.fromTo(elem, { x: () => (window.innerWidth * (imgPosXList[index] / 100)) - (window.innerWidth / 2) + (elem.offsetWidth / 2), y: () => (window.innerHeight * (imgPosYList[index] / 100)) - (window.innerHeight / 2) + (elem.offsetHeight / 2) }, { x: () => 0, y: () => 0, opacity: 0, duration: 30 }, index === 0 ? '+=0' : '-=30');
            });
        }

        // 파티클 플로팅 애니메이션 종료.
        for(let i = 0 ; i < this.scatterImgElemList.length ; i++) {
            this.impactCampusTimeline.to(this.scatterImgElemList[i], {css: {'animation': 'none'}, duration: 1 }, i === 0 ? "+=0" : "-=1");
        }

        // [씨앗 애니메이션]
        this.impactCampusTimeline.fromTo(this.seedElem, { scaleX: 0, scaleY: 0 }, { scaleX: 1, scaleY: 1, duration: 30 });
        this.impactCampusTimeline.fromTo(this.stemElem, { scaleY: 0, y: 150 }, { scaleY: 1, y: 0, duration: 5 }, "-=5");
        this.impactCampusTimeline.fromTo(this.leafLeftElem, { scaleX: 0, x: 65 }, { scaleX: 1, x: 0, ease: 'expo.out', duration: 5 }, "-=2");
        this.impactCampusTimeline.fromTo(this.leafRightElem, { scaleX: 0 }, { scaleX: 1, ease: 'expo.out', duration: 5 }, "-=5");

        this.impactCampusTimeline.fromTo(this.messageElemList[2], { opacity: 0 }, { opacity: 1, duration: 10 }); // '그래서 우리는 ...'
        this.impactCampusTimeline.fromTo(this.waveElem, { scaleX: 0, scaleY: 0 }, { scaleX: 2, scaleY: 2, transformOrigin: "50% 48%", duration: 20 }, "-=10");
        this.impactCampusTimeline.fromTo(this.waveElem, { opacity: 1 }, { opacity: 0, duration: 20, ease: 'power4.in' },"-=15");


        // 가로 스크롤 진행 ( #3-07 )
        this.campusDivList.forEach((elem, index) => {
            this.impactCampusTimeline.to(elem, { x: () => -window.innerWidth, duration: 60 },index === 0 ? "+=70" : "-=60");
        });

        // 백그라운드 라인(노랑) 부분 이동.
        this.impactCampusTimeline.to(this.bgline1Elem, { xPercent: () => -5, duration: 20 }, "-=20");
        this.impactCampusTimeline.to(this.bgline1AfterElem, { xPercent: () => -5, duration: 20 }, "-=20");
        this.impactCampusTimeline.to(this.bgline2Elem, { xPercent: () => -5, duration: 20 }, "-=20");

        const [animations, lottieScrollTrigger] = createResultCollector(this.LottieScrollTrigger.bind(this))

        // this.ScrollLineLottieFront();
        lottieScrollTrigger({
            target: '#lottie-bg-yellow-1',
            path: isMobile() ? './assets/lottie/MO_Campus_3_06-19_Yellowline_Appear.json' : './assets/lottie/Campus_3_06-15_Yellowline_Appear.json',
            start: () => isMobile() ? '800% bottom' : '700% bottom',
            end: () => isMobile() ? '+=200%' : '+=200%', // 값이 적을수록 스크롤 빠름.
            id: 'bg-yellow-01',
            // markers: true,
            preserveAspectRatio: 'none',
            direction: 'normal',
            segment: [0, 90]
        });

        lottieScrollTrigger({
            target: '#lottie-bg-yellow-1-1',
            path: isMobile() ? './assets/lottie/MO_Campus_3_06-19_Yellowline_Appear.json' : './assets/lottie/Campus_3_06-15_Yellowline_Appear.json',
            start: () => isMobile() ? '4000% bottom' :  '3200% bottom',
            end: () => isMobile() ? '+=500%' : '+=500%', // 값이 적을수록 스크롤 빠름.
            id: 'bg-yellow-01-after',
            // markers: true,
            preserveAspectRatio: 'none',
            direction: 'normal',
            onLeave: () => {
                this.setNormalLineElement('none');
            },
            onEnterBack: () => {
                this.setNormalLineElement('flex');
            }, 
        });

        //==========================================================================================
        // #3-07 ~ 3-11
        //==========================================================================================

        // 440 == window.innerWidth / 4 == 25vw  == 1leaf
        // 220 == window.innerWidth / 8 == 12.5vw == 0.5leaf

        let leafWidth = 50;  // 50%

        // ===========================================================================
        // mobile
        // ===========================================================================
        if(isMobile()) {

            const leafOpenSpeed = 50;
            const leafCloseSpeed = 50;
            const leafHoldSpeed = 50;
            const leafNextSpeed = 50;

            document.querySelector('#leaf01 defs pattern use').setAttribute('transform', 'translate(-240)');
            document.querySelector('#leaf02 defs pattern use').setAttribute('transform', 'translate(-420)');
            document.querySelector('#leaf03 defs pattern use').setAttribute('transform', 'translate(-330)');
            document.querySelector('#leaf04 defs pattern use').setAttribute('transform', 'translate(-320)');

            const defaultClipList = gsap.utils.toArray('#clip-d');
            
            defaultClipList.forEach((elem, index) => { 
                this.impactCampusTimeline.to(elem, {attr: {d: index % 2 === 0 ? 'M0 0H210C337.025 0 440 102.975 440 230V670H230C102.975 670 0 567.025 0 440V0Z' : 'M0 230C0 102.975 102.975 0 230 0H440V440C440 567.025 337.026 670 210 670H0V230Z' }});
            });

            this.impactCampusTimeline.fromTo(this.leaf01svg, { xPercent: leafWidth }, { xPercent: leafWidth });
            this.impactCampusTimeline.fromTo(this.leaf03svg, { xPercent: leafWidth }, { xPercent: leafWidth });

            // 잎 전체 이동.
            this.impactCampusTimeline.fromTo(this.leafGroup, { x: () => window.innerWidth }, { x: () => 0 - (this.leaf01svg.getBoundingClientRect().width / 2), duration: 30 });

            // 1. Program
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 0, 5);
            
            this.impactCampusTimeline.fromTo(this.leaf01Img, { x: 0, y: () => 0 }, { x:0, y: () => -690, duration: leafOpenSpeed });                                           // 가림막 올라감.
            this.leaf01TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220, y: () => 0 }, { x: -220, y: () => -690, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.

            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃.

            this.impactCampusTimeline.fromTo(this.leaf01Img, { x: 0, y: () => -690 }, { x: 0, y: () => 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 가림막 내려감.
            this.leaf01TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220, y: () => -672 }, { x: -220, y: () => 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.

            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.

            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 0, 5, "-=5");

            // 잎 전체 이동.
            this.impactCampusTimeline.to(this.leafGroup, { x: () => - (this.leaf02svg.getBoundingClientRect().width) - 10, duration: leafNextSpeed }); // -10 : margin-left: 10px 보정 
            this.impactCampusTimeline.fromTo(this.leafSvgList[2], { xPercent: -leafWidth }, { xPercent: -leafWidth, duration: leafNextSpeed }, `-=${leafNextSpeed}`);       // 다음 나뭇잎 위치 보간.



            // 2. Community
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 1, 5, "-=5");
            
            this.impactCampusTimeline.fromTo(this.leaf02Img, { x: 0, y: 0 }, { x: 0, y: -690, duration: leafOpenSpeed });                                           // 가림막 올라감.
            this.leaf02TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220, y: 0 }, { x: -220, y: -690, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃. 

            this.impactCampusTimeline.fromTo(this.leaf02Img, { x: 0, y: -690 }, { x: 0, y: 0, duration: leafCloseSpeed },`+=${leafHoldSpeed}`);                                      // 잠시 대기 후 가림막 내려감.
            this.leaf02TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220, y: -672 }, { x: -220, y: 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.

            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.

            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 1, 5, "-=5");

            // 잎 전체 이동.
            this.impactCampusTimeline.to(this.leafGroup, { x: () => 0 - (this.leaf02svg.getBoundingClientRect().width / 2) - (this.leaf03svg.getBoundingClientRect().width) - 20, duration: leafNextSpeed }); // -20 : margin-left 2개 간격 보정.
            this.impactCampusTimeline.fromTo(this.leafSvgList[3],{ xPercent: -leafWidth * 2 }, { xPercent: -leafWidth * 2, duration: leafNextSpeed });       // 다음 나뭇잎 위치 보간.


            // 3. Matching
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 2, 5, '-=5');
            // this.impactCampusTimeline.fromTo(this.leaf03svg, {x: () => 440}, {x: () => 0, duration: 5}); 
            // this.impactCampusTimeline.to(this.leaf03bg, 5, { attr: { d: "M0 0H650C777.026 0 880 102.975 880 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, "-=5");
            // this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220 }, { x: 0, duration: 5 }, "-=5"); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            this.impactCampusTimeline.fromTo(this.leaf03Img, { y: 0 }, { y: -790, duration: leafOpenSpeed });                                           // 사진 올라감.
            this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, {x: -220, y: 0 }, {x: -220, y: -672, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.\
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃. 

            this.impactCampusTimeline.fromTo(this.leaf03Img, { y: -790 }, { y: 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 사진 내려감.
            this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, {x: -220, y: -672 }, {x: -220, y: 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.
            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.
            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 2, 5, "-=5");

            // this.impactCampusTimeline.fromTo(this.leaf03svg, {x: () => 0}, {x: () => 440, duration: 5}); 
            // this.impactCampusTimeline.to(this.leaf03bg, 5, { attr: { d: "M0 0H210C337.025 0 440 102.975 440 230V670H230C102.975 670 0 567.025 0 440V0Z" } });
            this.impactCampusTimeline.fromTo(this.leafSvgList[3], { xPercent: -leafWidth * 2}, { xPercent: -leafWidth * 2, duration: leafNextSpeed });       // 다음 나뭇잎 위치 보간. ( 기존 위치로 복귀 )

            // this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: 0 }, { x: -220, duration: 5 }, "-=5"); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            // this.leafHorizontalItemMovement(3);

            // 잎 전체 이동.
            this.impactCampusTimeline.to(this.leafGroup, { x: () => 0 - (this.leaf02svg.getBoundingClientRect().width) - (this.leaf03svg.getBoundingClientRect().width) - 30, duration: leafNextSpeed });



            //4. Co-Learning
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 3, 5, '-=5');
            // this.impactCampusTimeline.to(this.leaf04bg, 5, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H880V440C880 567.025 777.026 670 650 670H0V230Z" } }, "-=5");
            // this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -170 }, { x: 0, duration: 5 }, "-=5"); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            this.impactCampusTimeline.fromTo(this.leaf04Img, { y: 0 }, { y: -760, duration: leafOpenSpeed });                                           // 사진 올라감.
            this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, {x: -170, y: 0 }, {x: -170, y: -690, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃.

            this.impactCampusTimeline.fromTo(this.leaf04Img, { y: -760 }, { y: 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 사진 내려감.
            this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, {x: -170, y: -690 }, { x: -170,y: 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.
            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.

            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 3, 5, "-=5");
            // this.impactCampusTimeline.fromTo(this.leaf02svg, {x: () => 0}, {x: () => 440, duration: 5}); 
            // this.impactCampusTimeline.to(this.leaf04bg, 5, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H440V440C440 567.025 337.026 670 210 670H0V230Z" } });
            // this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: () => 0 }, { x: () => -170, duration: 5 }, "-=5"); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            
        // ===========================================================================
        // Desktop
        // ===========================================================================
        } else {

            const leafOpenSpeed = 38;
            const leafCloseSpeed = 38;
            const leafHoldSpeed = 38;
            const leafNextSpeed = 38;

            document.querySelector('#leaf01 defs pattern use').setAttribute('transform', 'translate(0)');
            document.querySelector('#leaf02 defs pattern use').setAttribute('transform', 'translate(0)');
            document.querySelector('#leaf03 defs pattern use').setAttribute('transform', 'translate(0)');
            document.querySelector('#leaf04 defs pattern use').setAttribute('transform', 'translate(0)');

            // 잎 전체 이동.
            this.impactCampusTimeline.fromTo(this.leafGroup, { x: () => window.innerWidth }, { x: () => (window.innerWidth / 2) - (this.leaf01svg.getBoundingClientRect().width / 2), duration: 30 });

            // 1. Program
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 0, 5);
            this.impactCampusTimeline.fromTo(this.leaf01svg, { xPercent: leafWidth }, { xPercent: 0, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`);
            this.impactCampusTimeline.to(this.leaf01bg, leafOpenSpeed, { attr: { d: "M0 0H650C777.026 0 880 102.975 880 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, `-=${leafOpenSpeed}`);
            this.impactCampusTimeline.to(this.leaf01Img, leafOpenSpeed, { attr: { d: "M0 0H650C777.026 0 880 102.975 880 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, `-=${leafOpenSpeed}`);
            this.leaf01TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220 }, { x: 0, duration: leafOpenSpeed },`-=${leafOpenSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            this.impactCampusTimeline.fromTo(this.leaf01Img, { y: () => 0 }, { y: () => -690, duration: leafOpenSpeed });                                           // 사진 올라감.
            this.leaf01TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: () => 0 }, { y: () => -690, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃.

            this.impactCampusTimeline.fromTo(this.leaf01Img, { y: () => -690 }, { y: () => 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 사진 내려감.
            this.leaf01TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: () => -672 }, { y: () => 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.

            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 0, 5, "-=5");
            this.impactCampusTimeline.fromTo(this.leaf01svg, { xPercent: 0 }, { xPercent: leafWidth, duration: leafCloseSpeed }, "+=24");
            this.impactCampusTimeline.to(this.leaf01bg, leafCloseSpeed, { attr: { d: "M0 0H210C337.025 0 440 102.975 440 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, `-=${leafCloseSpeed}`);
            this.impactCampusTimeline.to(this.leaf01Img, leafCloseSpeed, { attr: { d: "M0 0H210C337.025 0 440 102.975 440 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, `-=${leafCloseSpeed}`);
            this.leaf01TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: 0 }, { x: -220, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 화면 좌표 함께 이동.

            // 잎 전체 이동.
            this.impactCampusTimeline.to(this.leafGroup, { x: () => (window.innerWidth / 2) - (this.leaf01svg.getBoundingClientRect().width / 2) - (this.leaf02svg.getBoundingClientRect().width) - 10, duration: leafNextSpeed }, `-=${leafNextSpeed}`); // -10 : margin-left: 10px 보정 
            this.impactCampusTimeline.fromTo(this.leafSvgList[2], { xPercent: -leafWidth }, { xPercent: 0, duration: leafNextSpeed }, `-=${leafNextSpeed}`);       // 다음 나뭇잎 위치 보간.
            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.


            // 2. Community
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 1, 5, "-=5");
            // this.impactCampusTimeline.fromTo(this.leaf02svg, {x: () => 440}, {x: () => 0, duration: 5}); 
            this.impactCampusTimeline.to(this.leaf02bg, leafOpenSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H880V440C880 567.025 777.026 670 650 670H0V230Z" } }, `-=${leafOpenSpeed}`);
            this.impactCampusTimeline.to(this.leaf02Img, leafOpenSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H880V440C880 567.025 777.026 670 650 670H0V230Z" } },`-=${leafOpenSpeed}`);
            this.leaf02TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220 }, { x: 0, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            this.impactCampusTimeline.fromTo(this.leaf02Img, { y: 0 }, { y: -690, duration: leafOpenSpeed });                                           // 사진 올라감.
            this.leaf02TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: 0 }, { y: -690, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃. 

            this.impactCampusTimeline.fromTo(this.leaf02Img, { y: -690 }, { y: 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 사진 내려감.
            this.leaf02TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: -672 }, { y: 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.

            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.

            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 1, 5, "-=5");
            // this.impactCampusTimeline.fromTo(this.leaf02svg, {x: () => 0}, {x: () => 440, duration: 5}); 
            this.impactCampusTimeline.to(this.leaf02bg, leafCloseSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H440V440C440 567.025 337.026 670 210 670H0V230Z" } }, "+=24");
            this.impactCampusTimeline.to(this.leaf02Img, leafCloseSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H440V440C440 567.025 337.026 670 210 670H0V230Z" } }, `-=${leafCloseSpeed}`);
            this.impactCampusTimeline.fromTo(this.leafSvgList[2], { xPercent: 0 }, { xPercent: -leafWidth, duration: leafNextSpeed }, `-=${leafNextSpeed}`);       // 다음 나뭇잎 위치 보간. ( 기존 위치로 복귀 )

            this.leaf02TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: 0 }, { x: -220, duration: leafNextSpeed }, `-=${leafNextSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            // this.leafHorizontalItemMovement(2);

            // 잎 전체 이동.
            this.impactCampusTimeline.to(this.leafGroup, { x: () => (window.innerWidth / 2) - (this.leaf01svg.getBoundingClientRect().width / 2) - (this.leaf02svg.getBoundingClientRect().width / 2) - (this.leaf03svg.getBoundingClientRect().width) - 20, duration: leafNextSpeed }, `-=${leafNextSpeed}`); // -20 : margin-left 2개 간격 보정.
            // this.impactCampusTimeline.fromTo(this.leafSvgList[3], { x: () => -440 }, { x: () => -440, duration: 5 }, "-=5");       // 다음 나뭇잎 위치 보간.


            // 백그라운드 라인(노랑) 포지션 복구.
            this.impactCampusTimeline.to(this.bgline1Elem, { xPercent: () => 0, duration: 30 }, `-=${leafNextSpeed}`);
            this.impactCampusTimeline.to(this.bgline1AfterElem, { xPercent: () => 0, duration: 30 }, "-=30");
            this.impactCampusTimeline.to(this.bgline2Elem, { xPercent: () => 0, duration: 30 }, "-=30");
                        

            // 3. Matching
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 2, 5, '-=5');
            // this.impactCampusTimeline.fromTo(this.leaf03svg, {x: () => 440}, {x: () => 0, duration: 5}); 
            this.impactCampusTimeline.to(this.leaf03bg, leafOpenSpeed, { attr: { d: "M0 0H650C777.026 0 880 102.975 880 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, `-=${leafOpenSpeed}`);
            this.impactCampusTimeline.to(this.leaf03Img, leafOpenSpeed, { attr: { d: "M0 0H650C777.026 0 880 102.975 880 230V670H230C102.975 670 0 567.025 0 440V0Z" } }, `-=${leafOpenSpeed}`);
            this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -220 }, { x: 0, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            this.impactCampusTimeline.fromTo(this.leaf03Img, { y: 0 }, { y: -790, duration: leafOpenSpeed });                                           // 사진 올라감.
            this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: 0 }, { y: -672, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })  // 폰트 올라감.\
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃. 

            this.impactCampusTimeline.fromTo(this.leaf03Img, { y: -790 }, { y: 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 사진 내려감.
            this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: -672 }, { y: 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.
            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.
            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 2, 5, "-=5");

            // this.impactCampusTimeline.fromTo(this.leaf03svg, {x: () => 0}, {x: () => 440, duration: 5}); 
            this.impactCampusTimeline.to(this.leaf03bg, leafCloseSpeed, { attr: { d: "M0 0H210C337.025 0 440 102.975 440 230V670H230C102.975 670 0 567.025 0 440V0Z" }}, "+=24");
            this.impactCampusTimeline.to(this.leaf03Img, leafCloseSpeed, { attr: { d: "M0 0H210C337.025 0 440 102.975 440 230V670H230C102.975 670 0 567.025 0 440V0Z" }}, `-=${leafCloseSpeed}`);
            this.impactCampusTimeline.fromTo(this.leafSvgList[3], { xPercent: -leafWidth }, { xPercent: -100, duration: leafNextSpeed }, `-=${leafNextSpeed}`);       // 다음 나뭇잎 위치 보간. ( 기존 위치로 복귀 )

            this.leaf03TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: 0 }, { x: -220, duration: leafNextSpeed }, `-=${leafNextSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            // this.leafHorizontalItemMovement(3);

            // 잎 전체 이동.
            this.impactCampusTimeline.to(this.leafGroup, { x: () => (window.innerWidth / 2) - (this.leaf01svg.getBoundingClientRect().width / 2) - (this.leaf02svg.getBoundingClientRect().width) - (this.leaf03svg.getBoundingClientRect().width) - 30, duration: leafNextSpeed }, `-=${leafNextSpeed}`);



            //4. Co-Learning
            // 오픈.
            // 문구 출력.
            this.displayLeafMesssage(true, 3, 5, '-=5');
            this.impactCampusTimeline.to(this.leaf04bg, leafOpenSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H880V440C880 567.025 777.026 670 650 670H0V230Z" } }, `-=${leafOpenSpeed}`);
            this.impactCampusTimeline.to(this.leaf04Img, leafOpenSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H880V440C880 567.025 777.026 670 650 670H0V230Z" } }, `-=${leafOpenSpeed}`);
            this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: -170 }, { x: 45, duration: leafOpenSpeed }, `-=${leafOpenSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

            this.impactCampusTimeline.fromTo(this.leaf04Img, { y:0 }, { y: -760, duration: leafOpenSpeed });                                           // 사진 올라감.
            this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: 0 }, { y: -690, duration: leafOpenSpeed },`-=${leafOpenSpeed}`); })  // 폰트 올라감.
            this.leafHorizontalTextOpacityAnimation(false); // 폰트 페이드아웃.

            this.impactCampusTimeline.fromTo(this.leaf04Img, { y: -760 }, { y: 0, duration: leafCloseSpeed }, `+=${leafHoldSpeed}`);                                      // 잠시 대기 후 사진 내려감.
            this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { y: -672 }, { y: 0, duration: leafCloseSpeed }, `-=${leafCloseSpeed}`); })     // 폰트 내려감.
            this.leafHorizontalTextOpacityAnimation(true); // 폰트 페이드인.

            // 클로즈.
            // 문구 숨김.
            this.displayLeafMesssage(false, 3, 5, "-=5");
            // this.impactCampusTimeline.fromTo(this.leaf02svg, {x: () => 0}, {x: () => 440, duration: 5}); 
            this.impactCampusTimeline.to(this.leaf04bg, leafCloseSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H440V440C440 567.025 337.026 670 210 670H0V230Z" } }, "+=24");
            this.impactCampusTimeline.to(this.leaf04Img, leafCloseSpeed, { attr: { d: "M0 230C0 102.975 102.975 0 230 0H440V440C440 567.025 337.026 670 210 670H0V230Z" } }, `-=${leafCloseSpeed}`);
            this.leaf04TextList.forEach((elem) => { this.impactCampusTimeline.fromTo(elem, { x: () => 45 }, { x: () => -170, duration: leafNextSpeed }, `-=${leafNextSpeed}`); })     // 화면이 열리면서 폰트도 비율에 맞게 x축 이동.

        }


        // // 백그라운드 라인(노랑) 부분 이동.
        // this.impactCampusTimeline.to(this.bgline1Elem, { xPercent: () => 0, duration: 3 }, "-=90");
        // this.impactCampusTimeline.to(this.bgline1AfterElem, { xPercent: () => 0, duration: 30 }, "-=1");
        // this.impactCampusTimeline.to(this.bgline2Elem, { xPercent: () => 0, duration: 30 }, "-=1");


        // 라인 애니메이션 시작.
        lottieScrollTrigger({
            target: '#lottie-bg-yellow-2',
            path:  isMobile() ? './assets/lottie/MO_Campus_3_19_Greenline_Disappear.json' : './assets/lottie/Campus_3_15_Greenline_Disappear.json',
            start: () => '2300% bottom',
            end: () => '+=700%',
            id: 'bg-yellow-02',
            // markers: true,
            preserveAspectRatio: 'none',
            direction: 'reverse',
            onLeave: () => {
                this.bgline2Elem.style.display = 'flex';
            },
            onEnterBack: () => {
                this.bgline2Elem.style.display = 'none';
            } 
        });

        // 가로 스크롤 진행 ( #3-12 )
        this.campusDivList.forEach((elem, index) => {
            this.impactCampusTimeline.to(elem, { x: () => -window.innerWidth * 2, duration: 30 }, index === 0 ? "-=0" : "-=30");
        });

        //  텍스트 표시. #3-12
        this.impactCampusTimeline.fromTo(this.title312Elem, { y: () => 20, opacity: 0 }, { y: () => 0, opacity: 1, duration: 10 }, '+=5');

        // 가로 스크롤 진행 ( #3-13 )
        this.campusDivList.forEach((elem, index) => {
            this.impactCampusTimeline.to(elem, { x: () => -window.innerWidth * 3, duration: 30 }, index === 0 ? "+=50" : "-=30");
        });

        // 픽토그램 아이콘 등장.
        this.pictoList.forEach((elem, index) => {
            this.impactCampusTimeline.fromTo(elem, { scaleX: () => 0, scaleY: () => 0 }, { scaleX: () => 1, scaleY: () => 1, duration: 10 }, index === 0 ? '+=0' : `-=${5 + this.getRandomInt(0, 5)}`)
        });


        lottieScrollTrigger({
            target: '#lottie-impact-130',
            trigger: '.st3-13',
            path: './assets/lottie/PC_Campus_3_13_130.json',
            // start: () => isMobile() ? '+=650% center' : '+=700% center',
            // end: () => isMobile() ? '+=40%' : '+=20%',
            start: () => isMobile() ? '3175% bottom' : '3100% bottom',
            end: () => isMobile() ? '+=20%' : '+=20%',
            id: 'bg-picto-130',
            // markers: true,
        });

        this.impactCampusTimeline.fromTo(this.pictoMessage1.querySelector('.center'), { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 5 }, "-=5");

        // 중앙 메시지 표시.
        this.impactCampusTimeline.to(this.pictoMessage1, { autoAlpha: 0, duration: 5 }, '+=65');
        lottieScrollTrigger({
            target: '#lottie-impact-1500',
            trigger: '.st3-13',
            path: './assets/lottie/PC_Campus_3_14_1500.json',
            start: () => isMobile() ? '3275% center' : '3300% bottom',
            end: () => isMobile() ?  '+=20%' : '+=20%',
            id: 'bg-picto-1500',
            // markers: true,
        });

        this.impactCampusTimeline.fromTo(this.pictoMessage2, { opacity: 0 }, { opacity: 1, duration: 5 });
        this.impactCampusTimeline.fromTo(this.pictoMessage2.querySelector('.center'), { opacity: 0, y: 20 }, { opacity: 1, y: 0, duration: 5 }, "-=5");


        // 픽토그램 교체.
        this.pictoNextList.forEach((elem, index) => {
            this.impactCampusTimeline.fromTo(elem, { y: () => 256 }, { y: () => 0, duration: 10 }, index === 0 ? '+=0' : `-=${5 + this.getRandomInt(0, 5)}`);
        });

        // 딜레이.
        // this.impactCampusTimeline.to({}, {duration: 5});

        // 가로 스크롤 진행 ( #3-15 )
        this.campusDivList.forEach((elem, index) => {
            this.impactCampusTimeline.to(elem, { x: () => -window.innerWidth * 4, duration: 30 }, index === 0 ? "+=50" : "-=30");
        });

        // 화면을 넘어가는 픽토그램들 숨김.
        this.impactCampusTimeline.to(this.pictoWrapper, {opacity: 0, duration: 10}, "-=20");

        // 백그라운드 라인 숨김처리.
        // if(!isMobile()) {
        //     this.impactCampusTimeline.to(this.bgline1AfterElem, {opacity: 0, duration: 10}, "-=20");
        //     this.impactCampusTimeline.to(this.bgline2Elem, {opacity: 0, duration: 10}, "-=20");
        // } else {
        //     this.impactCampusTimeline.to({}, {duration: 1}, "+=100");
        // }

        this.impactCampusTimeline.to(this.bgline1AfterElem, {autoAlpha: 0, duration: 10}, "-=20");
        this.impactCampusTimeline.to(this.bgline2Elem, {autoAlpha: 0, duration: 10}, "-=10");
    
        // IBC 문구 노출
        this.impactCampusTimeline.fromTo(this.ibcDescElem, { y: () => 20, opacity: 0 }, { y: () => 0, opacity: 1, duration: 10 }, "+=60");
        this.impactCampusTimeline.to({}, {duration: 1}, "+=30");
        

        // 그래프 바닥 라인.
        lottieScrollTrigger({
            target: '#lottie-graph-floor-line',
            trigger: '.st3-16',
            path: isMobile() ? './assets/lottie/MO_Campus_3_16_Line.json' : './assets/lottie/Campus_3_16_Line.json',
            // start: () => isMobile() ? '+=950% center' : '+=900% center',
            // end: () => '+=50%',
            start: () => isMobile() ? '3450% center' : '3450% center',
            end: () => '+=45%',
            id: 'lottie-graph-floor-line',
            // markers: true,
        });


        // 그래프.
        lottieScrollTrigger({
            target: '#lottie-graph',
            trigger: '.st3-16',
            path: isMobile() ? './assets/lottie/MO_Campus_3_16_Graph.json' : './assets/lottie/PC_Campus_3_16_Graph.json',
            start: () => isMobile() ? '3540% center' : '3540% center',
            end: () => '+=40%',
            id: 'lottie-graph',
            // markers: true,
        });

        // 메시지 숨김 ( 시간 딜레이용 )
        // this.impactCampusTimeline.to({}, { opacity: 0, duration: 10 }, "+=100");

                

        // 세로 스크롤 시작. ( 구 캠퍼스 2 )
        // this.impactCampusTimeline.to(this.campusDivHorizontalWrapper, {y: () => -window.innerHeight, duration: 30});
        this.campusDivList.forEach((elem, index) => {
            this.impactCampusTimeline.to(elem, { y: () => -window.innerHeight, duration: 30 },index === 0 ? "+=10" : "-=30");
        });

        // 화면 아래로 스크롤.
        this.impactCampusTimeline.fromTo(this.campusScrollerWrapperElem, {y: () => window.innerHeight}, {y: () => 0, duration: 30}, ">-5");



        //=======================================================================================================================================================================================
        // Mobile.
        //=======================================================================================================================================================================================
        if(isMobile()) {

            // 커리어 목록 페이드 인.
            this.impactCampusTimeline.fromTo(this.careerItemTexts[0], { x: 0, y: () => 20, xPercent: 0, yPercent:0, opacity: 0 }, { x: 0, y: () => 0, xPercent: 0, yPercent:0, opacity: 1, duration: 30 });
            this.impactCampusTimeline.fromTo(this.careerItemImgs[0], { x: 0, y: () => 20, xPercent: 0, yPercent:0, opacity: 0 }, { x: 0, y: () => 0, xPercent: 0, yPercent:0, opacity: 1, duration: 30 }, "-=30");

            this.impactCampusTimeline.to(this.careerItemTexts[0], {opacity: 0},"+=50");
            this.impactCampusTimeline.to(this.careerItemImgs[0], {opacity: 0});

            this.impactCampusTimeline.fromTo(this.careerItemTexts[1], { x: 0, y: () => 20, xPercent: 0, yPercent:0, opacity: 0 }, { x: 0, y: () => 0, xPercent: 0, yPercent:0, opacity: 1, duration: 30 });
            this.impactCampusTimeline.fromTo(this.careerItemImgs[1], { x: 0, y: () => 20, xPercent: 0, yPercent:0, opacity: 0 }, { x: 0, y: () => 0, xPercent: 0, yPercent:0, opacity: 1, duration: 30 }, "-=30");


        //=======================================================================================================================================================================================
        // Desktop.
        //=======================================================================================================================================================================================
        } else {

            // 커리어 목록 페이드 인.
            this.careerItemTexts.forEach((elem, index) => {
                this.impactCampusTimeline.fromTo(elem, { y: () => 20, opacity: 0 }, { y: () => 0, opacity: 1, duration: 10 }, index === 0 ? '+=0' : '-=10');
            });
            this.careerItemImgs.forEach((elem, index) => {
                this.impactCampusTimeline.fromTo(elem, { y: () => 20, opacity: 0 }, { y: () => 0, opacity: 1, duration: 10 }, index === 0 ? '-=4' : '-=10'); // 타이틀과 픽토그램 등장 딜레이 -=4
            });

        }



        lottieScrollTrigger({
            target: '#lottie-bg-green-1',
            trigger: '.st3-16',
            path: isMobile() ? './assets/lottie/MO_Campus_3_22-26_Greenline_Appear.json' : './assets/lottie/Campus_3_17-21_Greenline_Appear.json',
            start: () => isMobile() ? '4100% top' : '3900% top',
            end: () => isMobile() ? '+=350%' : '+=350%',
            id: 'bg-green-01',
            preserveAspectRatio: 'none',
            // markers: true,
        });

        lottieScrollTrigger({
            target: '#lottie-bg-green-2',
            trigger: '.st3-16',
            path: isMobile() ? './assets/lottie/MO_Campus_3_22-26_Greenline_Appear.json' : './assets/lottie/Campus_3_17-21_Greenline_Appear.json',
            start: () => isMobile() ? '4150% top' : '3950% top',
            end: () => isMobile() ? '+=400%' : '+=400%',
            id: 'bg-green-02',
            preserveAspectRatio: 'none',
            // markers: true,
        });


        // 화면 아래로 스크롤.
        this.impactCampusTimeline.fromTo(this.campusScrollerWrapperElem, {y: () => 0}, {y: () => -window.innerHeight, duration: 30}, '+=60');


        // 3-18 텍스트 출력.
        this.impactCampusTimeline.fromTo(this.partMsg, {
            y: () => 20,
            opacity: 0
        }, {
            y: () => 0,
            opacity: 1,
            duration: 5
        });

        // 3-18 부서 아이콘 페이드.
        this.partsItems.forEach((elem, index, array) => {
            this.impactCampusTimeline.fromTo(elem,
                {
                    opacity: 0,
                    scaleX: () => 0,
                    scaleY: () => 0,
                },
                {
                    opacity: 1,
                    scaleX: () => 1,
                    scaleY: () => 1,
                    duration: 30,
                }, index == 0 ? '+=0' : '-=25');
        });


        this.impactCampusTimeline.to({}, {duration: 15});

        if(!isMobile()) {
            // 가로 스크롤 - 이동. ( 페이지당 duration 5 )
            this.impactCampusTimeline.to(this.campusScrollerWrapperElem, {x: () => -window.innerWidth - (window.innerWidth / 4), duration: 30}, "+=100");
            if(window.innerWidth < 1024) {
                this.impactCampusTimeline.to(this.campusScrollerWrapperElem, {x: () => -(window.innerWidth * 2) + 50, duration: 30}, "+=50");
                this.impactCampusTimeline.to(this.campusScrollerWrapperElem, {x: () => -window.innerWidth * 3, duration: 30}, "+=50");
            } else {
                this.impactCampusTimeline.to(this.campusScrollerWrapperElem, {x: () => -window.innerWidth * 2, duration: 30}, "+=50");
                this.impactCampusTimeline.to(this.campusScrollerWrapperElem, {x: () => -window.innerWidth * 3, duration: 30}, "+=50");
            }
            // this.impactCampusTimeline.to(this.campusScrollerWrapperElem, {x: () => -window.innerWidth * 3, duration: 135}, "+=35");
            // this.impactCampusTimeline.to({}, {duration: 1},"+=45");
        } else {
            // 가로 스크롤 - 이동. ( 페이지당 duration 5 )
            this.impactCampusTimeline.fromTo(this.campusScrollerWrapperElem, { x: () => 0},                     { x: () => -window.innerWidth,      duration: 30}, "+=66" );
            this.impactCampusTimeline.fromTo(this.campusScrollerWrapperElem, { x: () => -window.innerWidth},    { x: () => -window.innerWidth * 2, duration: 30}, "+=66" );
            this.impactCampusTimeline.fromTo(this.campusScrollerWrapperElem, { x: () => -window.innerWidth * 2},{ x: () => -window.innerWidth * 3, duration: 30}, "+=66" );
        }

        this.impactCampusTimeline.to({}, { duration:1 });

        this.impactCampusTimeline.set('#lottie-bg-green-5', {css: {display: 'none'}});
        this.impactCampusTimeline.set('#lottie-bg-green-5-reverse', {css: {display: 'block'}});


        // 비디오 재생버튼 페이드.
        this.impactCampusTimeline.fromTo(this.videoPlayWrapperElem, {opacity:0}, {opacity:1, duration: 10},"+=10");
        // 완료후 트랜지션 커버 활성화.
        this.impactCampusTimeline.set(this.campusCoverElem, {css: {display: 'block'}});

        this.impactCampusTimeline.to({}, {duration:1}, "+=60");


        // Scroll To Next 버튼 애니메이션.
        if(document.querySelector('.scroll-down-wrapper.campus .scroll-contents').childElementCount === 0) {
            bodymovin.loadAnimation({
                container: document.querySelector('.scroll-down-wrapper.campus .scroll-contents'),
                renderer: "svg",
                loop: true,
                autoplay: true,
                path: './assets/lottie/PC_ScrollToNext_Light.json'
            });
        }

        // 비디오 재생 버튼 표시.
        // this.impactCampusTimeline.fromTo(this.videoPlayWrapperElem, {opacity:0}, {opacity:1, duration: 10});
        // this.videoDimTimeline = gsap.timeline({ paused: true });
        // this.videoDimTimeline.fromTo(this.videoPlayWrapperElem, { opacity: 0 }, { opacity: 1, duration: 10 });

        lottieScrollTrigger({
            timeline: this.lottieLineTimeline,
            trigger: '.st3-16',
            target: '#lottie-bg-green-3',
            path: isMobile() ? './assets/lottie/MO_Campus_3_22-26_Greenline_Appear.json' : './assets/lottie/Campus_3_17-21_Greenline_Appear.json',
            // start: () => '100% top',
            // end: () => '+=650%',
            start: () => isMobile() ? '4150% top' : '4150% top',
            end: () => isMobile() ? '+=400%' : '+=650%',
            id: 'bg-green-03',
            preserveAspectRatio: 'none',
            // markers: true,
        });

        lottieScrollTrigger({
            timeline: this.lottieLineTimeline,
            trigger: '.st3-16',
            target: '#lottie-bg-green-4',
            path: isMobile() ? './assets/lottie/MO_Campus_3_22-26_Greenline_Appear.json' : './assets/lottie/Campus_3_17-21_Greenline_Appear.json',
            // start: () => '100% top',
            // end: () => '+=650%',
            start: () => isMobile() ? '4150% top' : '4150% top',
            end: () => isMobile() ? '+=400%' : '+=650%',
            id: 'bg-green-04',
            preserveAspectRatio: 'none',
            // markers: true,
        });

        lottieScrollTrigger({
            timeline: this.lottieLineTimeline,
            trigger: '.st3-16',
            target: '#lottie-bg-green-5',
            path: isMobile() ? './assets/lottie/MO_Campus_3_22-26_Greenline_Appear.json' : './assets/lottie/Campus_3_17-21_Greenline_Appear.json',
            // start: () => '100% top',
            // end: () => '+=650%',
            start: () => isMobile() ? '4250% top' : '4250% top',
            end: () => isMobile() ? '+=400%' : '+=650%',
            id: 'bg-green-05',
            preserveAspectRatio: 'none',
            // markers: true,
            // onEnterBack: () => {
            //     document.querySelector('#lottie-bg-green-5').style.display = 'flex';
            //     document.querySelector('#lottie-bg-green-5-reverse').style.display = 'none';
            // },
            // onLeave: () => {
            //     document.querySelector('#lottie-bg-green-5').style.display = 'none';
            //     document.querySelector('#lottie-bg-green-5-reverse').style.display = 'flex';
            // }
        });

        lottieScrollTrigger({
            timeline: this.lottieLineTimeline,
            trigger: '.st3-16',
            target: '#lottie-bg-green-5-reverse',
            path: isMobile() ? './assets/lottie/MO_Campus_3_22-26_Greenline_Disappear.json' : './assets/lottie/Campus_3_17-21_Greenline_Disappear.json',
            // start: () => '200% top',
            // end: () => '+=650%',
            start: () => isMobile() ? '4750% top' : '4750% top',
            end: () => isMobile() ? '+=325%' : '+=325%',
            id: 'bg-green-05-reverse',
            preserveAspectRatio: 'none',
            // markers: true,
            // onEnterBack: () => {
            //     this.videoDimTimeline.reverse();
            // },
            // onLeave: () => {
            //     this.videoDimTimeline.play();
            // }
        });


        return Promise.all(animations)
    }

    kill() {
        if(this.impactCampusTimeline) {
            this.impactCampusTimeline.eventCallback("onEnter", null);
            this.impactCampusTimeline.eventCallback("onEnterBack", null);
            this.impactCampusTimeline.eventCallback("onLeave", null);

            // this.impactCampusTimeline.getChildren().forEach(child => {
            //     // gsap.set(child, {clearProps: "all"});
            //     child.kill();
            // });

            this.impactCampusTimeline.clear().kill();
            this.impactCampusTimeline = null;
        }
    }

    /**
     * GNB 색상 갱신.
     * @param {'light' | 'dark'} type 타입.
     */
    updateGNB(type) {
        if (!isMobile()) return;
        if (type === 'dark') {
            if (!this.gnbGlobalNavbar.classList.contains('dark')) this.gnbGlobalNavbar.classList.add('dark');
            if (!this.gnbDropdown.classList.contains('dark')) this.gnbDropdown.classList.add('dark');
            document.querySelector('.svg-navbtn-content g circle').setAttribute('fill', '#001B24');
        } else {
            this.gnbGlobalNavbar.classList.remove('dark');
            this.gnbDropdown.classList.remove('dark');
            document.querySelector('.svg-navbtn-content g circle').setAttribute('fill', 'white');
        }
    }

    // 무작위 정수.
    getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    leafHorizontalItemMovement(startIdx) {
        if (this.leafSvgList) {
            for (let i = startIdx; i < this.leafSvgList.length; i++) {
                this.impactCampusTimeline.to(this.leafSvgList[i], {
                    x: () => -440 * (startIdx - 1),
                    duration: 5
                }, "-=5");
            }
        }
    }

    // #03-7 나뭇잎 텍스트 투명도 조정 애니메이션.
    leafHorizontalTextOpacityAnimation(isFadeIn) {
        this.leaf01TextList.forEach(elem => this.impactCampusTimeline.fromTo(elem, { opacity: () => isFadeIn ? 0.6 : 1 }, { opacity: isFadeIn ? 1 : 0.6, duration: 5 }, "-=5")); // 사진 열리는 애니메이션 = 10
        this.leaf02TextList.forEach(elem => this.impactCampusTimeline.fromTo(elem, { opacity: () => isFadeIn ? 0.6 : 1 }, { opacity: isFadeIn ? 1 : 0.6, duration: 5 }, "-=5"));
        this.leaf03TextList.forEach(elem => this.impactCampusTimeline.fromTo(elem, { opacity: () => isFadeIn ? 0.6 : 1 }, { opacity: isFadeIn ? 1 : 0.6, duration: 5 }, "-=5"));
        this.leaf04TextList.forEach(elem => this.impactCampusTimeline.fromTo(elem, { opacity: () => isFadeIn ? 0.6 : 1 }, { opacity: isFadeIn ? 1 : 0.6, duration: 5 }, "-=5"));
    }


    displayLeafMesssage(isFadeIn, index, duration, gsapdelay) {
        if (this.leafMsgList.length > 0) {
            this.impactCampusTimeline.fromTo(this.leafMsgList[index], { opacity: isFadeIn ? 0 : 1 }, { opacity: isFadeIn ? 1 : 0, duration: duration }, gsapdelay ?? '+=0');
            if (isFadeIn) this.impactCampusTimeline.fromTo(this.leafMsgList[index], { y: () => 10 }, { y: () => 0, duration: duration, ease: 'Power4.easeIn' }, `-=${duration}`);
        }
    }


    /** 
     * 정방향으로 재생하는 라인 애니매이션이 마지막에 도달하면 숨김 처리.
     * 역방향 라인은 반대로 처리.
     * @param {'flex' | 'none'} state 숨기기 / 보이기
     */
    setNormalLineElement(displayState) {
        this.bgline1Elem.style.display = displayState;
        this.bgline2Elem.style.display = displayState === 'flex' ? 'none' : 'flex';
    }




    lottieTest() {
        bodymovin.loadAnimation({
            container: document.getElementById('lottietest'), // Required
            path: './assets/lottie/Celebrate_5_01-07_Line_Appear.json', // Required
            renderer: 'svg', // Required
            // initialSegment: [0, 70],
        });
    }


    LottieScrollTrigger(vars) {
        const targetElem = document.querySelector(`${vars.target}`);
        if(targetElem.hasChildNodes()) {
            targetElem.innerHTML = '';
        }
        let playhead = { frame: 0 },
            target = targetElem,
            speeds = { slow: "+=2000", medium: "+=1000", fast: "+=800" },
            st = {
                trigger: vars.trigger ? document.querySelector(vars.trigger) : target,
                scrub: 1,
                // markers: true,
                // invalidateOnRefresh: true,
                onEnterBack: () => vars.onEnterBack,
                onLeave: () => vars.onLeave,
            },
            animation = lottie.loadAnimation({
                container: target,
                renderer: "svg",
                loop: false,
                autoplay: false,
                path: vars.path,
                initialSegment: vars.segment, // [0, 70] // totalFrames == 180
                rendererSettings: {
                    preserveAspectRatio: vars.preserveAspectRatio ?? 'xMidYMid meet'
                }
            });
        // console.log(180 / (targetElem.offsetWidth / window.innerWidth) );

        for (let p in vars) { // let users override the ScrollTrigger defaults
            st[p] = vars[p];
        }

        return new Promise((resolve) => {
            animation.addEventListener("DOMLoaded", function () {
                //================================================
                // 커스터마이징 체크.
                //================================================
                const backgroundLine = targetElem.id.startsWith('lottie-bg-') && targetElem.querySelector('svg g g g path');
                if(backgroundLine) {
                    // gsap.set(backgroundLine, {attr: {'stroke-width': 1}});
                }
    
                if(targetElem.id === 'lottie-bg-green-5-reverse' && !isMobile()) {
                    // gsap.set(targetElem.querySelector('svg'), {attr: {'viewBox': '0 0 7156 1720', 'width': '7156', 'height': '1720'}});
                }
    
                if(targetElem.id === 'lottie-graph-floor-line') {
                    gsap.set(targetElem.querySelector('svg g g g path'), {attr: {'stroke-width': 2}});
                }
    
                //================================================
    
                if (vars.timeline) {
                    vars.timeline.to(playhead, {
                        frame: animation.totalFrames - 1,
                        ease: "none",
                        onUpdate: () => {
                            // if(vars.id === 'bg-green-05-reverse') {
                            //     console.log(`${vars.target} - ${playhead.frame}`);
                            // }
                            // if( vars.segment && vars.segment[1] < playhead.frame) {
                            //     playhead.frame = vars.segment[1];
                            // }
                            animation.goToAndStop(playhead.frame, true)
                        },
                        onComplete: () => {
                            // targetElem.style.display = "none";
                        },
                        scrollTrigger: st
                    });
                } else {
                    gsap.to(playhead, {
                        frame: animation.totalFrames - 1,
                        ease: "none",
                        onUpdate: () => {
                            // console.log(`${vars.target} - ${playhead.frame}`);
                            animation.goToAndStop(playhead.frame, true)
                        },
                        onComplete: () => {
                            // targetElem.style.display = "none";
                        },
                        scrollTrigger: st
                    });
                }
    
                resolve(animation);
            });
        })
    }

    getTimeline() {
        return this.impactCampusTimeline;
    }
    getScrollTrigger() {
        return this.impactCampusTimeline.scrollTrigger;
    }

}

export default ImpactCampus;